import { Theme, css } from '@emotion/react';

export const formLabelRoot = ({ colors, font, spacing }: Theme) => css`
  color: ${colors.textBase};
  font-family: ${font.medium};
  font-weight: 500;
  font-size: 1.8rem;
  line-height: 1.33;
  margin-bottom: ${spacing(1)}px;
`;

export const formGroupRoot = ({ spacing }: Theme) => css`
  margin-bottom: ${spacing(1)}px;
  .MuiFormControlLabel-root {
    margin-left: -${spacing(1)}px;
  }
  .MuiIconButton-root {
    padding: 6px;
  }
`;

export const formHelperTextRoot = () => css`
  margin-top: 0;
`;
